export class InvoiceFilter {
  constructor(
    customerNameOrNumber: string,
    dateFrom?: Date,
    dateTo?: Date,
    invoiceGroupId?: string
  ) {
    this.dateFrom = dateFrom;
    this.dateTo = dateTo;
    this.customerNameOrNumber = customerNameOrNumber;
    this.invoiceGroupId = invoiceGroupId;
  }

  invoiceGroupId?: string;
  dateFrom?: Date;
  dateTo?: Date;
  customerNameOrNumber: string;
}
